import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ConversationToolUsageEntity } from './conversation-tool-usage.entity';

export enum EntityReferenceRelationshipType {
	CREATED = 'created',
	MODIFIED = 'modified',
	READ = 'read',
	DELETED = 'deleted',
	REFERENCED = 'referenced',
}

export enum EntityReferenceEntityType {
	CLIENT = 'client',
	CLIENT_NOTE = 'client_note',
	CLIENT_VISIT = 'm_sm_client_visit',
	EVENT_OCCURRENCE = '_event_occurrence',
	ISSUE = 'issue',
	ISSUE_NOTE = 'issue_note',
	ORDER_QUOTE = 'order_quote',
	ORDER_QUOTE_DETAIL = 'order_quote_detail',
	ORDER = 'order',
	ORDER_DETAIL = 'order_detail',
	OPPORTUNITY = 'm_sm_client_opportunity',
	/** PD-15938: a rep's sales day (sales_trip). */
	SALES_TRIP = 'sales_trip',
	/** PD-17097: a job (the jobs add-on). */
	JOB = 'job',
}

@Entity('_conversation_tool_usage_entity_reference')
@Index(['toolUsageId'])
@Index(['entityType', 'entityId'])
@Index(['relationshipType'])
export class ConversationToolUsageEntityReferenceEntity extends BaseEntity {
	@Column('int', {
		name: '_fk_conversation_tool_usage__id',
		unsigned: true,
	})
	public toolUsageId!: number;

	@ManyToOne(() => ConversationToolUsageEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'CASCADE',
	})
	@JoinColumn([
		{ name: '_fk_conversation_tool_usage__id', referencedColumnName: 'id' },
	])
	public toolUsage!: ConversationToolUsageEntity;

	@Column({
		name: 'entity_type',
		type: 'varchar',
		length: 100,
		nullable: false,
		comment: 'The type of entity (table name)',
	})
	public entityType!: string;

	@Column({
		name: 'entity_id',
		type: 'int',
		unsigned: true,
		nullable: false,
		comment: 'The ID of the entity',
	})
	public entityId!: number;

	@Column({
		name: 'relationship_type',
		type: 'enum',
		enum: EntityReferenceRelationshipType,
		nullable: false,
		comment: 'The type of relationship to the entity',
	})
	public relationshipType!: EntityReferenceRelationshipType;
}
